module.exports = __webpack_public_path__ + "static/media/national.c2d73547.png";